import { useAppSelector } from "../../../app/hooks"
import { ErrorText } from "../../../common/errorText"

import { TimeField } from "../../selectorFields"
import { IDateFieldProperties } from "../fields"
import Tooltip from "../tooltip"

export interface TimeRangeFieldProperties extends IDateFieldProperties {
  fromValue?: string
  toValue?: string
  fromName?: string
  toName?: string
  readonly?: boolean
  hasChanges?: boolean
  showTimeRangeError?: boolean
  isEmpty?: boolean
  hasError?: boolean
  clearErrors?: boolean
}
const TimeRangeField = (props: TimeRangeFieldProperties) => {
  const { useLocalTime } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const showDivider = props.readonly ? props.fromValue || props.toValue : true
  const showStartAsterisk = props.readonly && !props.fromValue && props.toValue
  const showEndAsterisk = props.readonly && props.fromValue && !props.toValue

  const asterisk = <p className="ocs-field-readonly">*</p>

  return (
    <div
      className={
        "ocs-range-field d-flex flex-column h-100 justify-content-end pos-rel" +
        (props.readonly && props.hasChanges
          ? useLocalTime
            ? " has-changes local-time"
            : " has-changes"
          : "")
      }
    >
      <div className="d-flex">
        {props.caption && <label>{props.caption}</label>}
        {props.hasError && <Tooltip>{ErrorText.timeRangeErrorText}</Tooltip>}
      </div>

      <div className="pos-rel ocs-range">
        <TimeField
          name={props.fromName}
          value={props.fromValue}
          onChange={props.onChange}
          readonly={props.readonly}
          isEmpty={props.isEmpty}
          hasError={props.hasError}
          clearErrors={props.clearErrors}
          touched={props.touched}
        />
        {showStartAsterisk && asterisk}
        {showDivider && (
          <div className={!props.readonly ? "ocs-range-field-divider" : ""}>
            <p
              className={
                props.readonly
                  ? "ocs-field-readonly ocs-range-field-divider-readonly"
                  : ""
              }
            >
              -
            </p>
          </div>
        )}
        {showEndAsterisk && asterisk}
        <div className={!props.readonly ? "ocs-range-field-last" : ""}>
          <TimeField
            name={props.toName}
            value={props.toValue}
            onChange={props.onChange}
            readonly={props.readonly}
            isEmpty={props.isEmpty}
            hasError={props.hasError}
            clearErrors={props.clearErrors}
            touched={props.touched}
          />
        </div>
      </div>
    </div>
  )
}

export default TimeRangeField
